import React from 'react';

const companyLogos = [
  {
    name: 'Progressive',
    url: 'https://images.contentstack.io/v3/assets/blt62d40591b3650da3/blt483e097d64d66a25/66476d224ac76ee67740f2d5/logo-progressive.svg',
  },
  {
    name: 'Meesho',
    url: 'https://www.meesho.com/assets/svgicons/meeshoLogo.svg',
  },
  {
    name: 'IQVIA',
    url: 'https://upload.wikimedia.org/wikipedia/commons/thumb/3/34/Iqvia-logo-color.svg/500px-Iqvia-logo-color.svg.png',
  },
  {
    name: 'Newmark',
    url: 'https://www.nmrk.com/assets/icons/newmark-logo-black.svg',
  },
  {
    name: 'Dietitian Live',
    url: 'https://dietitianlive.com/wp-content/uploads/2024/08/DL-logo-new.svg',
  },
  {
    name: 'CarMax',
    url: 'https://upload.wikimedia.org/wikipedia/commons/thumb/e/ed/CarMax_logo.svg/2560px-CarMax_logo.svg.png',
  },
  {
    name: 'Domyn',
    url: 'https://mma.prnewswire.com/media/2704148/Domyn_Logo.jpg?w=200',
  },
  {
    name: 'GE HealthCare',
    url: 'https://mms.businesswire.com/media/20231005678195/en/1907724/4/GE_HealthCare_logo_NEW_March_2023.jpg?download=1',
  },
];

const CompanyLogoCarousel = () => {
  // Duplicate logos for seamless infinite scroll
  const duplicatedLogos = [...companyLogos, ...companyLogos];

  return (
    <section className="py-16 bg-white border-t border-gray-200 overflow-hidden" data-testid="company-logos-section">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Heading */}
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900">
            Webinars by Experts from Top Companies
          </h2>
        </div>
      </div>

      {/* Logo Carousel */}
      <div className="relative w-full overflow-hidden group">
        {/* Gradient Masks for smooth fade effect */}
        <div className="absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r from-white to-transparent z-10 pointer-events-none" />
        <div className="absolute right-0 top-0 bottom-0 w-24 bg-gradient-to-l from-white to-transparent z-10 pointer-events-none" />

        {/* Scrolling Container */}
        <div 
          className="flex items-center gap-16 animate-scroll group-hover:pause-animation"
          style={{
            width: 'fit-content',
          }}
        >
          {duplicatedLogos.map((logo, index) => (
            <div
              key={`${logo.name}-${index}`}
              className="flex-shrink-0 flex items-center justify-center h-16 px-4 transition-opacity duration-300 opacity-80 hover:opacity-100"
            >
              <img
                src={logo.url}
                alt={logo.name}
                className="h-[50px] w-auto max-w-[160px] object-contain"
                onError={(e) => {
                  e.target.style.display = 'none';
                }}
              />
            </div>
          ))}
        </div>
      </div>

      {/* CSS Animation */}
      <style>{`
        @keyframes scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
        
        .animate-scroll {
          animation: scroll 40s linear infinite;
        }
        
        .group:hover .animate-scroll {
          animation-play-state: paused;
        }
        
        .pause-animation {
          animation-play-state: paused;
        }
      `}</style>
    </section>
  );
};

export default CompanyLogoCarousel;
